import { Col, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import GenericCard from '../../../components/GenericCards';
import { formatPrice } from '../../../utils/utils';

export const Disbursements = () => {
  const disbursements = [
    {
      type: 'Hardship Withdrawal',
      availableAmount: 24340.0,
      description:
        'You can request a Hardship Withdrawal to meet a qualified financial need. This withdrawal cannot be rolled over and is subject to income tax.',
    },
    {
      type: 'Age 59 1/2 Withdrawal',
      availableAmount: 321773.82,
      description:
        'This withdrawal can be rolled over to an IRA or Qualified Plan. Any taxable money not rolled over is subject to income tax.',
    },
    {
      type: 'Final Distribution',
      availableAmount: 321773.82,
      description:
        'This amount represents your entire account balance that is available upon your separation from service. This amount can be rolled over to an IRA or Qualified Plan. Any taxable money not rolled over is subject to income tax.',
    },
  ];
  return (
    <>
      <GenericCard variant={'white'} className={'mt-9'}>
        <Row className="align-items-center">
          <Col className={'col-10'}>
            <h5>Available for Loans</h5>
          </Col>
          <Col className={'col-lg-2 col-12'}>
            <Button color={'blue'} className={'w-100'}>
              Make a Withdrawal
            </Button>
          </Col>
          <Col className={'col-12 overflow-auto'}>
            <Row
              className={'overflow-hidden'}
              style={{
                minWidth: '650px',
              }}
            >
              <Col>
                <Row className="text-fs-6 fw-light pt-3 lh-xs border-bottom px-3 pb-6">
                  <Col className="text-start fw-normal pe-0 col-lg-2 col-4 ">
                    Type
                  </Col>
                  <Col className="text-start fw-normal pe-0 col-lg-2 col-3 ">
                    Amount Available
                  </Col>
                  <Col className="text-start fw-normal pe-0 col-lg-8 col-5 ">
                    Descriptions
                  </Col>
                </Row>

                {disbursements.map((disbursement, index) => {
                  return (
                    <Row
                      className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom"
                      key={index}
                    >
                      <Col className="col-lg-2 pe-0 col-4 text-start  pt-2">
                        {disbursement.type}
                      </Col>
                      <Col className="col-lg-2 text-start pe-0 col-3  pt-2">
                        {formatPrice(
                          Number(disbursement.availableAmount),
                          'en-US',
                          {
                            currency: 'USD',
                            style: 'currency',
                            minimumFractionDigits: 0,
                          }
                        )}
                      </Col>
                      <Col className="col-lg-8 pe-0 pt-2 pb-2 col-5 text-start">
                        {disbursement.description}
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </Col>
          <Col className={'mt-10'}>
            <Blockquote>
              <span className={'text-dark-gray fw-bold'}>Did you know?</span>
              <ul className="text-dark-gray">
                <li>The money in your [Plan Name] is your money.</li>
                <li>
                  However, due to the special tax advantages this plan has,
                  there are restrictions on accessing this money before you
                  retire or terminate employment.
                </li>
                <li>
                  Plan rules do allow you to take out loans and withdrawals
                  while you are still working, but you may have to pay taxes and
                  penalties.
                </li>
              </ul>
            </Blockquote>
          </Col>
        </Row>
      </GenericCard>
    </>
  );
};
